import { combineReducers } from "redux";
import booksReducer from "./books/booksReducer";
import filterReducer from "./filter/filterReducer";
import formReducer from "./form/formReducer";
import searchReducer from "./search/searchReducer";
const rootReducer = combineReducers({
  books: booksReducer,
  form: formReducer,
  filter: filterReducer,
  search: searchReducer,
});

export default rootReducer;
